import { setWarningT, SET_WARNING } from "../reducers/WarningState"


export const SetWarning = ( data: setWarningT['data'] ) => {
  return ( {
    type: SET_WARNING,
    data: data
  } )
}
